<div class="row justify-content-end p-3">
    <div class="col-3 my-2">
        <mat-form-field appearance="outline" class="search-bar">
            <mat-label class="search-bar-label">
                <mat-icon class="search-icon">search</mat-icon>
                <span>Search</span>
            </mat-label>
            <input matInput (keyup)="applySearch($event)" [(ngModel)]="searchKeyword">
            <button type="button" *ngIf="searchKeyword" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div class="mt-2 mb-3">
        <div class="table-responsive">
            <table mat-table matSort [dataSource]="pendingOrganizationsDataSource" class="mat-elevation-z8">
                <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                    <ng-container [ngSwitch]="column.column">
                        <ng-container *ngSwitchCase="'pillStatus'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <app-pill 
                                        [backgroundColor]="this.getOrganizationPillStatusColor(element[column.column])"
                                        fontColor="white"
                                        [text]="element[column.column]"></app-pill>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            @if(column.renderHtml) {
                                <td mat-cell *matCellDef="let element" [innerHTML]="element[column.column]"></td>
                            } @else {
                                <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                            }
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnNames;" (click)="onRowClick(row)"></tr>
                @if(loading && searchKeyword) {
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            No data matching the filter "{{ searchKeyword }}"
                        </td>
                    </tr>
                }
                @if (loading && !searchKeyword) {
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            Loading New/Pending Organizations..
                        </td>
                    </tr>
                }
            </table>
        </div>
        <div *ngIf="loading.value" class="d-flex justify-content-center">
            <mat-spinner></mat-spinner>
        </div>
        <div class="d-flex paginator-row align-items-baseline">
            <div class="col-10">
                <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="pageSize || 10" [length]="tableLength" aria-label="Select page" showFirstLastButtons></mat-paginator>
            </div>
            <div class="col-2 d-flex align-items-baseline">
                <mat-form-field class="go-to" id="goToPage" style="width:90px;">
                    <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber" step="1">
                </mat-form-field>
                <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
            </div>
        </div>
    </div>
</div>